import type { RunVercelResult } from '@cli-types/next-adapter/vercel.js'

/** Vercel's name-conflict wording varies across CLI versions, so the 409 status is matched too. */
export function isNameTaken(result: RunVercelResult): boolean {
  return /already exists|already taken|already in use|name.*taken|conflict|\b409\b/i.test(
    `${result.stdout}\n${result.stderr}`
  )
}
